export enum lotTypesEnum {
	apartment = 'apartment',
	parking = 'parking'
}
